import type { Offer } from "@types_def/models/offer.types";

export const DriverNameCell = ({ children }: { children?: Pick<Offer, "driver"> }) =>
  children?.driver?.fullName ?? null;
